import styled from "@emotion/styled";

import { theme } from "../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

type Place = "panel" | "footer";

export interface ActionItemRootProps {
    place: Place;
}

export const ActionItemRoot = styled.li<ActionItemRootProps>(
    () => ({
        margin: 0,
        display: "flex",
        ":hover": {
            cursor: "pointer",
        },
    }),
    props =>
        props.place === "panel" && {
            ":hover": {
                backgroundColor: theme(props).lists.items.accentLow.backgroundColor,
            },
        },
    props =>
        props.place === "footer" && {
            ":hover": {
                backgroundColor: theme(props).keyPalette.panelBackgroundColor,
            },
            ":hover span:last-child": {
                textDecoration: "underline",
            },
        }
);

export const ActionItemLink = styled.a<{ disabled?: boolean; place: Place }>(props => ({
    fontSize:
        props.place === "footer"
            ? theme(props).typography.header4.fontSize.css()
            : theme(props).typography.primary.fontSize.css(),
    color: props.disabled ? theme(props).typography.link.inactiveColor : theme(props).typography.primary.color,
    lineHeight: "32px",
    padding: props.place === "footer" ? "0 8px" : "0 20px",
    display: "block",
    overflow: "hidden",
    textOverflow: "ellipsis",
    textDecoration: "none",
}));
